import apiService from "@/api-service";
import { AxiosRequestConfig } from "axios";
import { useState } from "react";

export default function useAPIDownload() {

    const [ busy, setBusy ] = useState<boolean>(false);

    const download = (
        request: { 
            method: 'post' | 'get', 
            path: string, 
            data: {[key: string]: any} 
        }, 
        filename: string, 
        callbacks: {
            success?: () => void,
            error?: (e: any) => void,
            finally?: () => void
        }) => {
            if (busy) {
                return;
            }

            setBusy(true);

            const config = { responseType: 'blob' } as AxiosRequestConfig;

            (request.method === "post" ? apiService.post(request.path, request.data, config) : apiService.get(request.path, config)).then(response => {
                // create file link in browser's memory
                const href = URL.createObjectURL(response.data);
    
                // create "a" HTML element with href to file & click
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
    
                // clean up "a" element & remove ObjectURL
                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                if (callbacks.success) {
                    callbacks.success();
                }
            }, callbacks.error).finally(() => {
                setBusy(false);

                if (callbacks.finally) {
                    callbacks.finally();
                }
            });
        }

    return download;
}